<template>
  <div class="tpl_wrap">
    <!-- 管理员（acctype=3）：模板维护界面 -->
    <template v-if="isAdmin">
      <div class="toolbar">
        <el-form :inline="true" :model="listQuery" class="query_form">
          <el-form-item label="名称">
            <el-input v-model="listQuery.name" placeholder="名称模糊搜索" clearable
                      style="width: 180px" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="上架">
            <el-select v-model="listQuery.enabled" placeholder="全部" clearable style="width: 110px">
              <el-option label="已上架" :value="true" />
              <el-option label="已下架" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增模板</el-button>
      </div>

      <div class="tpl_cards" v-loading="listLoading">
        <div v-for="row in listData" :key="row.template_id" class="tpl_card">
          <div class="card_head">
            <i class="el-icon-user-solid card_icon"></i>
            <span class="card_name" :title="row.display_name || row.name">{{ row.display_name || row.name }}</span>
            <el-tag :type="row.enabled ? 'success' : 'info'" size="mini">{{ row.enabled ? '已上架' : '已下架' }}</el-tag>
          </div>
          <div class="card_sub">标识：{{ row.name }} · 排序 {{ row.sort || 0 }}</div>
          <div class="card_summary">{{ row.description || '（暂无描述）' }}</div>
          <div class="persona_block">
            <div class="block_k">角色画像</div>
            <div class="persona_text">{{ row.persona }}</div>
          </div>
          <div class="card_meta">
            <div class="meta_row"><span class="meta_k">平台工具</span><span>{{ (row.tool_ids || []).length }} 个</span></div>
            <div class="meta_row"><span class="meta_k">更新时间</span><span>{{ fmtTime(row.utime) }}</span></div>
          </div>
          <div class="card_actions">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger_text" @click="handleDel(row)">删除</el-button>
          </div>
        </div>
        <el-empty v-if="!listLoading && !listData.length" :description="emptyText" class="cards_empty" />
      </div>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </template>

    <!-- 企业（acctype=2）：只读目录 + 使用模板创建 -->
    <template v-else>
      <div class="toolbar">
        <span class="catalog_tip">员工模板由平台统一维护，选择模板创建数字员工后将自动预置角色画像并绑定平台公共工具</span>
      </div>
      <div class="tpl_cards" v-loading="catalogLoading">
        <div v-for="row in catalogData" :key="row.template_id" class="tpl_card">
          <div class="card_head">
            <i class="el-icon-user-solid card_icon"></i>
            <span class="card_name" :title="row.display_name || row.name">{{ row.display_name || row.name }}</span>
            <el-tag type="success" size="mini">可创建</el-tag>
          </div>
          <div class="card_sub">标识：{{ row.name }}</div>
          <div class="card_summary">{{ row.description || '（暂无描述）' }}</div>
          <div class="persona_block">
            <div class="block_k">角色画像</div>
            <div class="persona_text">{{ row.persona }}</div>
          </div>
          <div class="tool_block">
            <div class="block_k">包含工具（{{ (row.tools || []).length }}）</div>
            <div class="tool_tags">
              <el-tag v-for="t in row.tools || []" :key="t.tool_id" size="mini"
                      :type="t.enabled ? '' : 'info'" class="tool_tag">{{ t.name }}</el-tag>
              <span v-if="!(row.tools && row.tools.length)" class="block_empty">-</span>
            </div>
          </div>
          <div class="card_actions">
            <el-button type="text" size="small" @click="openUse(row)">使用模板</el-button>
          </div>
        </div>
        <el-empty v-if="!catalogLoading && !catalogData.length" :description="emptyText" class="cards_empty" />
      </div>
    </template>

    <!-- 抽屉：模板新增/编辑（管理员，右侧滑出） -->
    <el-drawer :visible.sync="editVisible" direction="rtl" size="520px" :with-header="false"
               :modal="true" append-to-body :modal-append-to-body="true"
               class="tpl_drawer" :before-close="closeEdit" @open="raiseDrawer">
      <div class="drawer_head">
        <span>{{ editId ? '编辑员工模板' : '新增员工模板' }}</span>
        <i class="el-icon-close drawer_close" @click="closeEdit"></i>
      </div>
      <div class="drawer_body">
        <el-alert type="info" :closable="false" class="drawer_tip">
          <div slot="title">
            员工模板由平台统一维护：企业选择模板创建数字员工时，将自动预置下方角色画像并绑定所选平台公共工具。
          </div>
        </el-alert>
        <el-form ref="editForm" :model="form" :rules="rules" label-width="90px" size="small">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" maxlength="64" placeholder="全局唯一" />
          </el-form-item>
          <el-form-item label="展示名">
            <el-input v-model="form.display_name" maxlength="64" placeholder="创建员工时的默认展示名" />
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="form.description" type="textarea" :rows="2" maxlength="200" />
          </el-form-item>
          <el-form-item label="角色画像" prop="persona">
            <el-input v-model="form.persona" type="textarea" :rows="6" maxlength="2000"
                      placeholder="预置系统提示词，创建员工时自动带入" />
          </el-form-item>
          <el-form-item label="平台工具">
            <el-select v-model="form.tool_ids" multiple filterable clearable
                       placeholder="创建员工时自动绑定这些平台公共工具" style="width: 100%">
              <el-option v-for="t in platformTools" :key="t.tool_id"
                         :label="t.name + (t.type === 'mcp' ? '（MCP）' : '') + (t.enabled ? '' : '（已停用）')"
                         :value="t.tool_id" :disabled="!t.enabled" />
            </el-select>
          </el-form-item>
          <el-form-item label="上架">
            <el-switch v-model="form.enabled" />
            <div class="field_tip">仅已上架模板会出现在企业员工的商店目录中。</div>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" />
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button @click="closeEdit">取 消</el-button>
        <el-button type="primary" :loading="editSubmiting" @click="submitEdit">保 存</el-button>
      </div>
    </el-drawer>

    <!-- 弹窗：使用模板创建数字员工（企业） -->
    <el-dialog title="从模板创建数字员工" :visible.sync="useVisible"
               width="560px" v-dialogDrag :modal-append-to-body="false" v-if="useVisible && useRow">
      <div class="use_persona">
        <div class="use_persona_label">模板角色画像（创建后可在员工编辑中调整）</div>
        <div class="use_persona_text">{{ useRow.persona }}</div>
      </div>
      <el-form ref="useForm" :model="useForm" :rules="useRules" label-width="90px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="useForm.name" maxlength="64" placeholder="同企业下唯一" />
        </el-form-item>
        <el-form-item label="展示名">
          <el-input v-model="useForm.display_name" maxlength="64" placeholder="默认取模板展示名" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="useForm.description" type="textarea" :rows="2" maxlength="200"
                    placeholder="默认取模板描述" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="useVisible = false">取 消</el-button>
        <el-button type="primary" :loading="useSubmiting" @click="submitUse">创 建</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isAdminAcc, isEnterprise } from '../utils'

// 员工商店：管理员(3)维护模板（platform 归属），企业(2)只读目录+从模板创建；个人(1) Tab 不渲染
export default {
  name: 'AiAgentTemplates',
  data() {
    return {
      isAdmin: isAdminAcc(),
      loaded: false,
      // 管理员模板列表
      listQuery: { name: '', enabled: '' },
      listData: [],
      listLoading: false,
      page: 1,
      limit: 20,
      total: 0,
      listReqSeq: 0,
      // 企业目录
      catalogData: [],
      catalogLoading: false,
      catReqSeq: 0,
      // 编辑弹窗
      editVisible: false,
      editId: null,
      editSubmiting: false,
      form: this.emptyForm(),
      platformTools: [],
      platformToolsLoaded: false,
      // 使用模板弹窗
      useVisible: false,
      useRow: null,
      useForm: { name: '', display_name: '', description: '' },
      useSubmiting: false,
      rules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        persona: [{ required: true, message: '请输入预置提示词', trigger: 'blur' }]
      },
      useRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    emptyText() {
      return this.isAdmin ? '暂无数据' : '暂无上架模板'
    },
    // 接口前缀按视角集中切换：管理员走 platform-*，企业走 catalog + add-from-template
    urls() {
      const m = { list: 'aiAgentTplCatalog' }
      if (this.isAdmin) {
        Object.assign(m, {
          list: 'aiAgentTplPlatformList', add: 'aiAgentTplPlatformAdd',
          edit: 'aiAgentTplPlatformEdit', del: 'aiAgentTplPlatformDel'
        })
      }
      const out = {}
      Object.keys(m).forEach(k => { out[k] = this.$baseUrl[m[k]] })
      return out
    }
  },
  methods: {
    emptyForm() {
      return { name: '', display_name: '', description: '', persona: '', tool_ids: [], enabled: true, sort: 0 }
    },
    // 关闭模板抽屉（before-close 回调与取消按钮共用）
    closeEdit() {
      this.editVisible = false
    },
    // 抽屉浮层置于页面内容之上（模块内存在高层级容器）
    raiseDrawer() {
      this.$nextTick(() => {
        if (this.$el && this.$el.style) this.$el.style.zIndex = 4000
      })
    },
    onActivate() {
      if (this.loaded) return
      if (this.isAdmin) this.loadList()
      else this.loadCatalog()
    },
    // ---------- 管理员：模板 CRUD ----------
    loadList() {
      this.listLoading = true
      const data = { page: this.page, limit: this.limit }
      if (this.listQuery.name) data.name = this.listQuery.name
      if (this.listQuery.enabled !== '' && this.listQuery.enabled !== null) data.enabled = this.listQuery.enabled
      const seq = ++this.listReqSeq
      this.$tools.asyncPost(this, this.urls.list, agentBody(data)).then((res) => {
        if (seq !== this.listReqSeq) return
        if (res.data.code == 0) {
          this.listData = res.data.data.data || []
          this.total = res.data.data.total || 0
          this.loaded = true // 成功才记缓存，失败切回 Tab 自动重试
        }
        this.listLoading = false
      }).catch(() => {
        if (seq === this.listReqSeq) this.listLoading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadList()
    },
    resetQuery() {
      this.listQuery = { name: '', enabled: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.limit = val; this.onSearch() },
    handlePageChange(val) { this.page = val; this.loadList() },
    openAdd() {
      this.form = this.emptyForm()
      this.editId = null
      this.editVisible = true
      this.loadPlatformTools()
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    openEdit(row) {
      // 行数据即列表全量返回，无需回查 get
      this.form = {
        name: row.name, display_name: row.display_name || '', description: row.description || '',
        persona: row.persona, tool_ids: [...(row.tool_ids || [])],
        enabled: !!row.enabled, sort: row.sort || 0
      }
      this.editId = row.template_id
      this.editVisible = true
      this.loadPlatformTools()
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    submitEdit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return
        this.editSubmiting = true
        const payload = {
          name: this.form.name, display_name: this.form.display_name,
          description: this.form.description, persona: this.form.persona,
          tool_ids: this.form.tool_ids, enabled: this.form.enabled, sort: this.form.sort
        }
        if (this.editId) payload.template_id = this.editId
        const url = this.editId ? this.urls.edit : this.urls.add
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '操作成功' })
            this.editVisible = false
            this.loadList()
          }
          this.editSubmiting = false
        }).catch((err) => {
          this.editSubmiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      const toolCnt = (row.tool_ids || []).length
      this.$MessageBox.confirm(
        `删除模板「${row.display_name || row.name}」不影响已创建的数字员工，确认删除？` +
        (toolCnt ? `（引用 ${toolCnt} 个平台工具）` : ''), '提示', { type: 'warning' }
      ).then(() => {
        this.$tools.asyncPost(this, this.urls.del, agentBody({ template_id: row.template_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.listData.length === 1 && this.page > 1) this.page -= 1
            this.loadList()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    // 平台工具下拉数据源（编辑弹窗打开时懒加载一次）
    loadPlatformTools() {
      if (this.platformToolsLoaded) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentPlatformToolsList,
        agentBody({ page: 1, limit: 100 })).then((res) => {
        if (res.data.code == 0) {
          this.platformTools = res.data.data.data || []
          this.platformToolsLoaded = true
        }
      }).catch(() => {})
    },
    // ---------- 企业：目录 + 使用模板 ----------
    loadCatalog() {
      this.catalogLoading = true
      const seq = ++this.catReqSeq
      this.$tools.asyncPost(this, this.urls.list, agentBody({})).then((res) => {
        if (seq !== this.catReqSeq) return
        if (res.data.code == 0) {
          this.catalogData = (res.data.data && res.data.data.data) || []
          this.loaded = true
        }
        this.catalogLoading = false
      }).catch(() => {
        if (seq === this.catReqSeq) this.catalogLoading = false
      })
    },
    openUse(row) {
      this.useRow = row
      this.useForm = {
        name: row.name, display_name: row.display_name || '', description: row.description || ''
      }
      this.useVisible = true
      this.$nextTick(() => this.$refs.useForm && this.$refs.useForm.clearValidate())
    },
    submitUse() {
      this.$refs.useForm.validate((valid) => {
        if (!valid) return
        this.useSubmiting = true
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsAddFromTpl, agentBody({
          template_id: this.useRow.template_id,
          name: this.useForm.name,
          display_name: this.useForm.display_name,
          description: this.useForm.description
        })).then((res) => {
          if (res.data.code == 0) {
            const failed = (res.data.data && res.data.data.failed_tool_ids) || []
            if (res.data.warn && failed.length) {
              // 部分平台工具不可用/绑定失败：成功但有警告（WARN_AGENT_TOOLS_PARTIAL）
              this.$message({ type: 'warning', message: (res.data.msg || '新增成功') + '，不可用工具：' + failed.join('、') })
            } else {
              this.$message({ type: 'success', message: '新增成功，可到「数字员工」查看' })
            }
            this.useVisible = false
          }
          this.useSubmiting = false
        }).catch((err) => {
          this.useSubmiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
  .catalog_tip {
    color: #909399;
    font-size: 13px;
  }
}
.tool_tag {
  margin: 0;
}
// 卡片式员工商店：自适应网格，卡片内依次为头像头部/描述/角色画像/工具/操作
.tpl_cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
  padding: 12px;
  min-height: 240px;
  background: #f9fafd;
  border-top: 1px solid #e9eaec;
}
.tpl_card {
  display: flex;
  flex-direction: column;
  min-height: 230px;
  padding: 12px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 4px #c0bfbf;
}
.card_head {
  display: flex;
  align-items: center;
  gap: 8px;
  .card_icon {
    color: #8c7ebb;
    font-size: 16px;
  }
  .card_name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.card_sub {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.card_summary {
  height: 36px;
  margin: 8px 0;
  font-size: 12px;
  line-height: 18px;
  color: #909399;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.persona_block,
.tool_block {
  flex: 1;
  padding: 8px 10px;
  margin-bottom: 8px;
  background: #f7f9fc;
  border-radius: 4px;
  font-size: 12px;
}
.block_k {
  margin-bottom: 4px;
  color: #909399;
}
.persona_text {
  color: #303133;
  line-height: 18px;
  white-space: pre-wrap;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tool_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.block_empty {
  color: #c0c4cc;
}
.card_meta {
  font-size: 12px;
  color: #606266;
  margin-top: 4px;
  .meta_row {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;
  }
  .meta_k {
    color: #909399;
  }
}
.card_actions {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid #f2f2f2;
}
.cards_empty {
  grid-column: 1 / -1;
}
.tpl_drawer {
  /deep/ .el-drawer__body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}
.drawer_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 20px;
  border-bottom: 1px solid #ebeef5;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  .drawer_close {
    font-size: 20px;
    color: #909399;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
  }
}
.drawer_body {
  flex: 1;
  padding: 16px 20px 8px;
  overflow: auto;
}
.drawer_footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.drawer_tip {
  margin-bottom: 14px;
}
.field_tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}
.use_persona {
  margin-bottom: 16px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  .use_persona_label {
    color: #909399;
    font-size: 12px;
    margin-bottom: 6px;
  }
  .use_persona_text {
    color: #303133;
    font-size: 13px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
.danger_text {
  color: #f56c6c;
}
</style>
